import React, { useState } from "react";

import { faUser, faWarehouseAlt, faEllipsisV } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, IconButton, Tooltip } from "@material-ui/core";

import { useTranslation } from "react-i18next";

import type { IPartnerUserRolesAndLabels } from "App/Modules/Models";

import "./_user-finder.scss";
import "./_icon-button.scss";

type OwnProps = {
    user: IPartnerUserRolesAndLabels;
    handleMenuClicked: (site: object, user: object, event: any) => void;
};

export const UserByCodeListItem = (props: OwnProps) => {
    const { t } = useTranslation();
    const { user, handleMenuClicked } = props;
    const [siteNumber, setSiteNumber] = useState(5);

    const showAllSites = (sites) => {
        setSiteNumber(sites);
    };

    return (
        <li className="entity-list__item">
            <a
                href={`/#!/partners/${user.partner.id}/users/${user.id}`}
                className="entity-list__item-link entity-list__item-link--padding"
            >
                <div className="entity-list__item-icon entity-list__item-icon--alt">
                    <FontAwesomeIcon icon={faUser} size="lg" />
                </div>
                <div className="entity-list__item-panel">
                    <div className="entity-list__item-value">
                        <p className="title title--h3 title--no-spacing">{user.fullName}</p>
                    </div>
                </div>
            </a>
            {user?.sites.length > 0 ? (
                <ul className="entity-list">
                    {user.sites.map((site, siteIndex) => {
                        if (siteIndex >= siteNumber) {
                            return null;
                        }
                        return (
                            <li className="entity-list__item" key={site.id}>
                                <a href={`/#!/sites/${site.id}`} className="entity-list__item-link">
                                    <div className="entity-list__item-icon entity-list__item-icon--alt">
                                        <FontAwesomeIcon icon={faWarehouseAlt} size="lg" />
                                    </div>
                                    <div className="entity-list__item-panel">
                                        <div className="entity-list__item-value">
                                            <p className="paragraph paragraph--small">{site.name}</p>
                                            <p className="caption">
                                                {t(`Entities.Role.${site.role ? site.role.name : "NoRole"}`)}
                                            </p>
                                        </div>
                                    </div>
                                </a>
                                <div className="entity-list__item-edit">
                                    {site.role ? (
                                        <IconButton
                                            className="icon-button"
                                            onClick={(event) => handleMenuClicked(site, user, event)}
                                        >
                                            <FontAwesomeIcon icon={faEllipsisV} />
                                        </IconButton>
                                    ) : (
                                        <Tooltip title={t("Gui.Common.UserNotPermitted")}>
                                            <span>
                                                <IconButton className="icon-button" disabled>
                                                    <FontAwesomeIcon icon={faEllipsisV} />
                                                </IconButton>
                                            </span>
                                        </Tooltip>
                                    )}
                                </div>
                            </li>
                        );
                    })}
                    {siteNumber <= user.sites.length ? (
                        <li className="user-finder__show-more-button">
                            <Button
                                variant="contained"
                                size="small"
                                color="primary"
                                onClick={() => showAllSites(user.sites)}
                            >
                                {t("Gui.Buttons.FindUserByCode.Show.All")}
                            </Button>
                        </li>
                    ) : null}
                </ul>
            ) : null}
        </li>
    );
};
